import {
  Pagination,
  PaginationContent,
  PaginationNext,
  PaginationPrevious,
} from "../../components/shareable/pagination";

const CustomerPagination = ({
  totalPages,
  currentPage,
  handlePageChange,
  totalItems,
}) => {
  return (
    <div className="flex justify-between items-center mt-6">
      <div className="flex-1 text-sm ml-2 text-gray-600">
        Showing page {currentPage} of {totalPages}{" "}
        {totalPages === 1 ? "page" : "pages"} • {totalItems} total items
      </div>

      {totalItems > 10 && (
        <Pagination>
          <PaginationContent className="flex items-center gap-4">
            <PaginationPrevious
              className={`
              inline-flex items-center justify-center 
              whitespace-nowrap rounded-md text-sm font-medium 
              ring-offset-background transition-all 
              focus-visible:outline-none focus-visible:ring-2 
              focus-visible:ring-ring focus-visible:ring-offset-2 
              disabled:pointer-events-none disabled:opacity-50 
              border border-gray-200 bg-white hover:bg-gray-50 
              hover:border-gray-300 hover:shadow-sm
              h-9 w-24 p-0 select-none
              ${
                currentPage === 1
                  ? "cursor-not-allowed opacity-50 text-gray-400"
                  : "cursor-pointer text-gray-700"
              }
            `}
              onClick={() =>
                currentPage > 1 && handlePageChange(currentPage - 1)
              }
              disabled={currentPage === 1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="transform transition-transform hover:-translate-x-0.5"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </PaginationPrevious>

            <PaginationNext
              className={`
              inline-flex items-center justify-center 
              whitespace-nowrap rounded-md text-sm font-medium 
              ring-offset-background transition-all 
              focus-visible:outline-none focus-visible:ring-2 
              focus-visible:ring-ring focus-visible:ring-offset-2 
              disabled:pointer-events-none disabled:opacity-50 
              border border-gray-200 bg-white hover:bg-gray-50 
              hover:border-gray-300 hover:shadow-sm
              h-9 w-24 p-0 select-none
              ${
                currentPage === totalPages
                  ? "cursor-not-allowed opacity-50 text-gray-400"
                  : "cursor-pointer text-gray-700"
              }
            `}
              onClick={() =>
                currentPage < totalPages && handlePageChange(currentPage + 1)
              }
              disabled={currentPage === totalPages}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="transform transition-transform hover:translate-x-0.5"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </PaginationNext>
          </PaginationContent>
        </Pagination>
      )}
    </div>
  );
};

export default CustomerPagination;